import { render, staticRenderFns } from "./dashboard-etaps.vue?vue&type=template&id=3c23b1a9"
import script from "./dashboard-etaps.vue?vue&type=script&lang=js"
export * from "./dashboard-etaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports